import { render, staticRenderFns } from "./FormularioPagoMultiva.vue?vue&type=template&id=3c23b651"
import script from "./FormularioPagoMultiva.vue?vue&type=script&lang=js"
export * from "./FormularioPagoMultiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports